export const environment = {
  production: true,
  // PRODUCCION
  apiTriidyUrl: 'https://triidy.info/serviciosTriidy/Servicio.asmx',
  apiTriidyUrlSales: 'https://triidy.info/serviciosTriidy/ventas.asmx',
  apiTriidyUrlRest: 'https://triidy.info/Rest',
  apiTriidyUrlRestSales: 'https://triidy.info/rest',
  apiTriidyUrlProduct: 'https://product.triidy.info/product',
  apiTriidyUrlWallet: 'https://wallet.triidy.info/wallet',
  apiTriidyUrlVentas: 'https://sales.triidy.info/Ventas',
  apiTriidyUrlIntegraciones: 'https://integrations.triidy.info/integrations',
  apiTriidyUrlLogistics: 'https://logistics.triidy.info/Logistics',
  apiTriidyUrlNotifications: 'https://notifications.triidy.info/notifications',
  apiTriidyUrlAuthTeam: 'https://triidy.info/Rest',
  apiEnviaUrl:
    'http://200.69.100.66/ServicioRESTConsultaEstados/Service1Consulta.svc',
  folderAwsImage: 'Productos/',
  folderAwsImageSupport: 'SoporteRecursos',
  folderAwsImageLogoTienda: 'Tiendas',
  folderAwsImageLogoMensa: 'mensajeros',
  folderAwsImageDocumentosTienda: 'Documentos',
  serviceToken: 'jq2gh66o6dxr.54',
  dbUsed: 'produccion',
  accessKeyId: 'AKIAVSTSWC3TT224LJRP',
  secretAccessKey: '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',
  keyLoginGeneral: 'n8wov5ko59gcn9yxzx2D5nmmlvbolatvisib4jg5a',
  id_tienda_login: '38317'



  // PRUEBAS
  // apiTriidyUrl: 'http://devopstriidy.com/serviciosTriidy/Servicio.asmx',
  // apiTriidyUrlSales: 'http://devopstriidy.com/serviciosTriidy/ventas.asmx',
  // apiTriidyUrlRest: 'http://devopstriidy.com/Rest',
  // apiTriidyUrlRestSales: 'http://devopstriidy.com/rest',
  // apiTriidyUrlProduct: 'http://devopstriidy.com/product',
  // apiTriidyUrlWallet: 'http://devopstriidy.com/wallet',
  // apiTriidyUrlVentas: 'http://devopstriidy.com/Ventas',
  // apiTriidyUrlIntegraciones: 'http://devopstriidy.com/integrations',
  // apiTriidyUrlLogistics: 'http://devopstriidy.com/Logistics',
  // apiTriidyUrlNotifications: 'http://devopstriidy.com/notifications',
  // apiTriidyUrlAuthTeam: 'https://triidy.info/Rest',
  // apiEnviaUrl:
  //   'http://200.69.100.66/ServicioRESTConsultaEstados/Service1Consulta.svc',
  // folderAwsImage: 'Pruebas/Productos/',
  // folderAwsImageSupport: 'Pruebas/SoporteRecursos',
  // folderAwsImageLogoTienda: 'Pruebas/Tiendas',
  // folderAwsImageLogoMensa: 'Pruebas/mensajeros',
  // folderAwsImageDocumentosTienda: 'Pruebas/Documentos',
  // serviceToken: '7jh95ññtñue2.y3-pw57',
  // dbUsed: 'pruebas',
  // accessKeyId: 'AKIAVSTSWC3TT224LJRP',
  // secretAccessKey: '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',
  // keyLoginGeneral: 'n8wov5ko59gcn9yxzx2D5nmmlvbolatvisib4iahi',
  // id_tienda_login: '37944'
  // firebase: {
  //   apiKey: "AIzaSyBjO_-OgsTJ79Yg1pqJ7LbJ7oC1ONwIkHk",
  //   authDomain: "triidy-4d70f.firebaseapp.com",
  //   projectId: "triidy-4d70f",
  //   storageBucket: "triidy-4d70f.appspot.com",
  //   messagingSenderId: "513640380896",
  //   appId: "1:513640380896:web:7b21902a18dfff6c689385"
  // }
};


/*
Para Triidy.com
  - En inicio dashboard template QUITAR aviso pruebas
  - En header nuevo de layout COMENTAR primera linea de letrero de pruebas
  - En folderAwsImage PONER esto 'Productos/'
  - En folderAwsImage PONER esto 'SoporteRecursos/'
  - En folderAwsImage PONER esto 'Tiendas/'
  - En folderAwsImage PONER esto 'Documentos/'
  - En serviceToken PONER esto 'jq2gh66o6dxr.54'


Para Triidy PRUEBAS
  - En inicio dashboard template PONER aviso pruebas
  - En header nuevo de layout DESCOMENTAR primera linea de letrero de pruebas
  - En folderAwsImage PONER esto 'Pruebas/Productos/'
  - En folderAwsImage PONER esto 'Pruebas/SoporteRecursos/'
  - En folderAwsImage PONER esto 'Pruebas/Tiendas/'
  - En folderAwsImage PONER esto 'Pruebas/Documentos/'
  - En serviceToken PONER esto '7jh95ññtñue2.y3-pw57'
 */
